export const ORCAMENTOS_CILIA = () => `/orcamentos-cilia`;
export const ORCAMENTOS_CILIA_DETAIL = (id: string = ':id') => `/orcamentos-cilia/${id}`;

// A configuração do módulo NÃO fica aqui: virou módulo da Administração do Sistema
// (`ADMIN_SISTEMA_CILIA`, em `views/admin-sistema/routes.ts`) em 12/08/2026. A rota
// antiga `/orcamentos-cilia/configuracoes` deixou de existir — o `:id` do detalhe
// casaria com ela, então manter as duas seria ambiguidade de rota, não retrocompatibilidade.
